export default __webpack_public_path__ + "static/media/dog2.fda2cb5d.jpg";